var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-cart-button",class:[
       {'header-cart-button--is-cncc': _vm.$is_cncc},
       {'header-cart-button--is-cfpc': _vm.$is_cfpc},
       {'header-cart-button--is-irf-ceeca': _vm.$is_irf_ceeca},
     ]},[_c('a',{staticClass:"button__link",attrs:{"href":_vm.goToPanier}},[(_vm.authenticated && _vm.countPanier)?_c('span',{staticClass:"button__count"},[_vm._v("\n      "+_vm._s(_vm.countPanier)+"\n    ")]):_vm._e(),_vm._v(" "),_c('font-awesome-icon',{staticClass:"button__icon",attrs:{"icon":_vm.icon,"size":_vm.size}}),_vm._v(" "),_c('span',{staticClass:"button__label"},[_vm._v("Mon panier")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }